/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TranslationTerminologiesProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Import a custom terminology CSV file. Languages are auto-detected from the file header.
   * @param requestBody
   * @returns any Terminology imported successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesTranslationTerminologiesImport(
    requestBody: {
      /**
       * Base64-encoded CSV file content
       */
      fileContent: string;
      /**
       * Original file name
       */
      fileName?: string;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/translationTerminologies/import',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Delete a custom translation terminology
   * @param identifier Translation terminology UUID
   * @returns void
   * @throws ApiError
   */
  public deleteApiServiceorganizationsProcessesTranslationTerminologies(
    identifier: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/processes/translationTerminologies/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

}
